import { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios"
import authConfig from "../../authConfig";
import { useSelector, useDispatch } from 'react-redux';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
    useAccount
} from "@azure/msal-react"

import {
    format,
    subHours,
    startOfMonth,
    endOfMonth,
    formatISO,
    subMonths,
    getYear,
    addMonths,
    parseISO,
    parse,
    toDate
} from 'date-fns';
import { enGB, cy } from 'date-fns/locale';
import Container from 'react-bootstrap/Container';
import SitePage from '../sitepage/SitePage';
import { Link, NavLink } from "react-router-dom";

function Committee(props) {
    const { t, i18n } = useTranslation();

    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal()
    const account = useAccount(accounts[0] || {})

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    //const [date, setDate] = useState(startOfMonth(Date.now()));

    const language = useSelector((state) => state.language.value);

    useEffect(() => {
        console.log("useEffect:requestData:" + loading);
        if (!loading) {
            loadData();
        }
    }, [language, props]);

    function loadData() {
        setError(null)
        setData([])
        if (isAuthenticated) {
            if (account && loading == false) {
                setLoading(true)
                instance
                    .acquireTokenSilent({
                        scopes: authConfig.api.scopes,
                        account: account
                    })
                    .then(response => {
                        if (response) {
                            console.log("Got access token:", response)
                            axios
                                .create({
                                    headers: { Authorization: `Bearer ${response.accessToken}` }
                                })
                                .get(authConfig.api.urls.getCommittee + "/" + props.id)
                                .then(function (response) {
                                    console.log(response.data);
                                    //response.data.outsideBodies.sort((a, b) => {
                                    //    return a.nameEn > a.nameEn;
                                    //});
                                    setData(response.data);
                                })
                                .catch(function (error) {
                                    setError("Error fetching data: " + error.message)
                                    console.error(error)
                                })
                                .then(function () {
                                    // always executed
                                    setLoading(false)
                                })
                        } else {
                            setError("Empty token??")
                            console.error("no token acquired")
                        }
                    })
                    .catch(error => {
                        setError("Error getting token: " + error.message)
                        console.error(error)
                        setLoading(false)
                    })
            } else {
                setError("No account...")
            }
        } else {
            axios
                .create({
                    /*headers: { Authorization: `Bearer ${response.accessToken}` }*/
                })
                .get(authConfig.api.urls.getCommittee + "/" + props.id)
                .then(function (response) {
                    console.log(response.data);
                    //response.data.outsideBodies.sort((a, b) => {
                    //    return a.nameEn > b.nameEn ? 1 : a.nameEn < b.nameEn ? -1 : 0;
                    //});
                    setData(response.data);
                })
                .catch(function (error) {
                    setError("Error fetching data: " + error.message)
                    console.error(error)
                })
                .then(function () {
                    // always executed
                    setLoading(false)
                })
        }
    }
    //
    function getFormattedDate(date) {
        if (date) {
            return format(new Date(date), "EEEE, do LLLL, yyyy h:mm bbb", { locale: i18n.language == 'en' ? enGB : cy });
        } else {
            return "";
        }
    }
    return data === null || loading ?
        (<></>) :
        (
            <>
                <h1>{language === 'cy' ? data.nameCy : data.nameEn}</h1>
                <p>
                    <b>{t("Purpose of committee")}</b>
                </p>
                <div dangerouslySetInnerHTML={{ __html: language === 'cy' ? data.descriptionCy : data.descriptionEn }} />
                <p>
                    <b>{t("Membership")}</b>
                </p>
                <ul>
                    {
                        data.membership ? data.membership.map((member, index) => (
                            <li key={index}>
                                {member.person.member ?
                                    (
                                        <Link to={"/member/" + member.person.member.id}>{t(member.person.title) + " " + member.person.firstname + " " + member.person.lastname}</Link>
                                    )
                                    :
                                    (
                                        <>
                                            {t(member.person.title) + " " + member.person.firstname + " " + member.person.lastname}
                                        </>
                                    )
                                }
                                {member.role.trim() === "" ? '' : " (" + t(member.role) +")"}
                            </li>
                        )) : ''
                    }
                </ul>
                <p>
                    <b>{t("Contact Information")}</b>
                </p>
                <div dangerouslySetInnerHTML={{ __html: language === 'cy' ? data.contactCy : data.contactEn}} />
            </>
        );
}
export default Committee;